import React from 'react';
import ActiveLanguageSelector from '../components/ActiveLanguageSelector';
import { recordUxEvent } from '../utils/uxTelemetry';

export type MetadataLanguageOption = {
  value: string;
  label: string;
};

interface MetadataLanguageSelectorProps {
  value: string;
  options: MetadataLanguageOption[];
  onChange: (value: string) => void;
  onAddLanguage: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
}

const MetadataLanguageSelector: React.FC<MetadataLanguageSelectorProps> = ({
  value,
  options,
  onChange,
  onAddLanguage,
  searchValue,
  onSearchChange,
}) => {
  const normalizedSearch = searchValue.trim().toLowerCase();
  const filteredOptions = normalizedSearch
    ? options.filter(option => option.label.toLowerCase().includes(normalizedSearch))
    : options;
  const showAddLanguageFooter = Boolean(normalizedSearch && filteredOptions.length === 0);
  const sourceLanguage = options.find(option => option.value === 'original')?.label || 'source';
  const isViewingOriginal = value === 'original';

  return (
    <div className="metadata-language-selector">
      <ActiveLanguageSelector
        dataTestId="tutorial:metadata:language-select"
        value={value}
        options={filteredOptions}
        onChange={(nextValue) => {
          recordUxEvent('metadata_edition_changed', {
            from_original: isViewingOriginal,
            to_original: nextValue === 'original',
          });
          onChange(nextValue);
        }}
        showSearch
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onAddLanguage={onAddLanguage}
        showAddLanguageFooter={showAddLanguageFooter}
        sourceLanguage={sourceLanguage}
        originalValue="original"
        contextLabel="Viewing edition"
        ariaLabel="Current metadata edition"
      />
    </div>
  );
};

export default MetadataLanguageSelector;
